import { create } from 'zustand';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../utils/firebase.js';

export const useAuthStore = create((set) => ({
  // State
  user: null,
  isAuthenticated: false,
  isAuthLoading: true, // Start as true to handle initial auth check
  error: null,

  setUser: (firebaseUser) => {
    set({
      user: firebaseUser,
      displayName: firebaseUser?.auth?.currentUser?.displayName,
      isAuthenticated: !!firebaseUser, 
      isAuthLoading: false,
      error: null
    });
  },

  setDisplayName: (newName) => set({ displayName: newName }),

  setLoading: (loadingStatus) => {
    set({ isAuthLoading: loadingStatus });
  },

  setError: (errorMessage) => {
    set({ error: errorMessage, isAuthLoading: false });
  },

  logout: () => {
    set({
      user: null,
      isAuthenticated: false,
      error: null
    });
  }
}));

// Listen to Firebase auth changes and update store
onAuthStateChanged(auth, (user) => {
  useAuthStore.getState().setUser(user);
  useAuthStore.getState().setLoading(false);
  if (!user) {
    useAuthStore.getState().logout();
  }
});